/* Kopie von assets/rescu-lwp.js (Lenoir-Premium), Schnappschuss 15.10.2026 fuer den Lenoir-Planer auf starkregen-d.
   Bewusst entkoppelt, damit spaetere Aenderungen der Lenoir-Familie die Kollektionsseite nicht veraendern. */
/* rescu-lwp: Lenoir® Wassersperre, Premium-Produktseite (15.10.2026).
   Alles hier ist Zugabe: Ohne dieses Script steht jede Section fertig und
   lesbar da (Querschnitt aufgerichtet, Zahlen final, Rechner mit Startwerten).
   Bausteine:
     1  Einblenden beim Scrollen (.lwp-in, nur für Elemente unterhalb des Folds)
     2  Zähler, Stoppuhr
     3  Querschnitt abspielen (--p 0 → 1) und Einsatzverlauf am Scroll
     4  Galerie, Einsatzbuch-Film
     5  Typwahl, Rechner/Planer
     6  Anfrageformular vorbelegen (#ContactForm aus rescu-lws-anfrage) */
(function () {
  'use strict';
  if (window.__lwpGeladen) return;
  window.__lwpGeladen = true;

  var ruhig = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fmt = new Intl.NumberFormat('de-DE');
  var fmt1 = new Intl.NumberFormat('de-DE', { minimumFractionDigits: 1, maximumFractionDigits: 1 });
  document.documentElement.classList.add('lwp-js');

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function imBild(el) {
    var r = el.getBoundingClientRect();
    return r.top < window.innerHeight && r.bottom > 0;
  }
  function weich(t) { return 1 - Math.pow(1 - t, 3); }
  function weichInOut(t) { return t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }

  /* ── 1 Einblenden ─────────────────────────────────────────────────── */
  function einblenden() {
    var ziele = $$('.lwp [data-lwp-beobachten], .lwp[data-lwp-beobachten]');
    if (ruhig || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('lwp-in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px 60px 0px', threshold: 0 });
    ziele.forEach(function (el) {
      /* Was beim Laden schon sichtbar ist, bleibt ruhig stehen (kein Flackern). */
      if (imBild(el)) return;
      io.observe(el);
    });
  }

  /* ── 2 Zähler ─────────────────────────────────────────────────────── */
  function zaehler() {
    if (ruhig || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        zaehle(e.target, 1400);
      });
    }, { threshold: .4 });
    $$('[data-lwp-zahl]').forEach(function (el) {
      if (imBild(el) && !el.hasAttribute('data-lwp-zahl-sofort')) return;
      if (el.hasAttribute('data-lwp-zahl-sofort')) { setTimeout(function () { zaehle(el, 2200); }, 650); return; }
      io.observe(el);
    });
  }
  function zaehle(el, dauer) {
    var roh = el.textContent;
    var m = roh.match(/(\d[\d.]*)(,\d+)?/);
    if (!m) return;
    var ziel = parseFloat(m[1].replace(/\./g, '') + (m[2] ? '.' + m[2].slice(1) : ''));
    var nachkomma = m[2] ? m[2].length - 1 : 0;
    var vor = roh.slice(0, m.index), nach = roh.slice(m.index + m[0].length);
    var f = new Intl.NumberFormat('de-DE', { minimumFractionDigits: nachkomma, maximumFractionDigits: nachkomma });
    var ring = el.closest('[data-lwp-uhr]');
    var fort = ring ? $('.lwp-uhr__fort', ring) : null;
    var t0 = null;
    el.style.fontVariantNumeric = 'tabular-nums';
    function schritt(t) {
      if (t0 === null) t0 = t;
      var k = Math.min(1, (t - t0) / dauer), w = weich(k);
      el.textContent = vor + f.format(ziel * w) + nach;
      if (fort) fort.style.strokeDashoffset = String(327 * (1 - w));
      if (k < 1) requestAnimationFrame(schritt); else el.textContent = roh;
    }
    requestAnimationFrame(schritt);
  }

  /* ── 3 Querschnitt ────────────────────────────────────────────────── */
  function setzeP(fig, p) {
    fig.__p = p;
    fig.style.setProperty('--p', p.toFixed(4));
    var fort = fig.closest('[data-lwp-prinzip]');
    if (fort) fort.style.setProperty('--p', p.toFixed(4));
  }
  function spieleBis(fig, ziel, dauer, fertig) {
    if (fig.__lauf) cancelAnimationFrame(fig.__lauf);
    var start = typeof fig.__p === 'number' ? fig.__p : 1;
    var t0 = null;
    function schritt(t) {
      if (t0 === null) t0 = t;
      var k = Math.min(1, (t - t0) / dauer);
      setzeP(fig, start + (ziel - start) * weichInOut(k));
      if (k < 1) fig.__lauf = requestAnimationFrame(schritt);
      else { fig.__lauf = null; if (fertig) fertig(); }
    }
    fig.__lauf = requestAnimationFrame(schritt);
  }
  function querschnitte() {
    $$('[data-lwp-qs="abspielen"]').forEach(function (fig) {
      var knopf = $('.lwp-qs__nochmal', fig);
      if (ruhig) return;
      function los() {
        setzeP(fig, 0);
        spieleBis(fig, 1, 4200, function () { if (knopf) knopf.hidden = false; });
      }
      if (knopf) knopf.addEventListener('click', function () { knopf.hidden = true; los(); });
      if (!('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (eintraege) {
        eintraege.forEach(function (e) {
          if (!e.isIntersecting) return;
          io.unobserve(fig);
          setTimeout(los, imBild(fig) ? 500 : 0);
        });
      }, { threshold: .45 });
      io.observe(fig);
    });
  }
  function geschichten() {
    $$('[data-lwp-prinzip="geschichte"]').forEach(function (sek) {
      var fig = $('[data-lwp-qs]', sek);
      var schritte = $$('[data-lwp-schritt]', sek);
      var status = $('[data-lwp-status]', sek);
      if (!fig || !schritte.length) return;
      var aktiv = -1;
      function waehle() {
        var mitte = window.innerHeight * (window.innerWidth < 990 ? .62 : .5);
        var beste = 0, abstand = Infinity;
        schritte.forEach(function (s, i) {
          var r = s.getBoundingClientRect();
          var d = Math.abs((r.top + r.bottom) / 2 - mitte);
          if (d < abstand) { abstand = d; beste = i; }
        });
        if (beste === aktiv) return;
        aktiv = beste;
        schritte.forEach(function (s, i) { s.classList.toggle('ist-aktiv', i === beste); });
        var ziel = parseFloat(schritte[beste].getAttribute('data-p'));
        if (isNaN(ziel)) ziel = 1;
        if (status) status.textContent = schritte[beste].getAttribute('data-titel') || '';
        if (ruhig) { setzeP(fig, ziel); return; }
        spieleBis(fig, ziel, 1100);
      }
      var wartet = false;
      window.addEventListener('scroll', function () {
        if (wartet) return;
        wartet = true;
        requestAnimationFrame(function () { wartet = false; waehle(); });
      }, { passive: true });
      window.addEventListener('resize', waehle);
      waehle();
    });
  }

  /* ── 4 Galerie und Film ───────────────────────────────────────────── */
  function galerien() {
    $$('[data-lwp-gal]').forEach(function (gal) {
      var band = $('[data-lwp-band]', gal);
      var minis = $$('[data-lwp-mini]', gal);
      if (!band) return;
      function geheZu(i) {
        var n = band.children.length;
        i = (i + n) % n;
        band.scrollTo({ left: band.clientWidth * i, behavior: ruhig ? 'auto' : 'smooth' });
      }
      function aktuell() { return Math.round(band.scrollLeft / Math.max(1, band.clientWidth)); }
      var zur = $('[data-lwp-zurueck]', gal), vor = $('[data-lwp-vor]', gal);
      if (zur) zur.addEventListener('click', function () { geheZu(aktuell() - 1); });
      if (vor) vor.addEventListener('click', function () { geheZu(aktuell() + 1); });
      minis.forEach(function (m, i) { m.addEventListener('click', function () { geheZu(i); }); });
      band.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); geheZu(aktuell() + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); geheZu(aktuell() - 1); }
      });
      band.addEventListener('scroll', function () {
        var i = aktuell();
        minis.forEach(function (m, j) { m.setAttribute('aria-current', j === i ? 'true' : 'false'); });
      }, { passive: true });
    });
    $$('[data-lwp-film]').forEach(function (sek) {
      var film = $('.lwp-film', sek);
      var leiste = $('.lwp-zeitleiste', sek);
      if (!film) return;
      function schiebe(r) {
        var karte = film.firstElementChild;
        var w = karte ? karte.getBoundingClientRect().width + 20 : 320;
        film.scrollBy({ left: r * w, behavior: ruhig ? 'auto' : 'smooth' });
      }
      var b = $$('.lwp-einsatz__nav button', sek);
      if (b[0]) b[0].addEventListener('click', function () { schiebe(-1); });
      if (b[1]) b[1].addEventListener('click', function () { schiebe(1); });
      function fort() {
        if (!leiste) return;
        var max = film.scrollWidth - film.clientWidth;
        var sicht = film.clientWidth / Math.max(1, film.scrollWidth);
        var k = max > 0 ? film.scrollLeft / max : 1;
        leiste.style.setProperty('--fort', ((sicht + (1 - sicht) * k) * 100).toFixed(1) + '%');
      }
      film.addEventListener('scroll', fort, { passive: true });
      window.addEventListener('resize', fort);
      fort();
    });
  }

  /* ── 5 Typwahl ────────────────────────────────────────────────────── */
  function typwahl() {
    $$('[data-lwp-typen]').forEach(function (sek) {
      $$('input[type="radio"]', sek).forEach(function (r) {
        r.addEventListener('change', function () {
          var panel = $('[data-typ="' + r.value + '"]', sek);
          if (!panel || ruhig) return;
          panel.classList.remove('ist-neu');
          void panel.offsetWidth;
          panel.classList.add('ist-neu');
        });
      });
    });
  }

  /* ── 5 Rechner / Planer ───────────────────────────────────────────── */
  var TYPEN_STANDARD = [
    { name: 'LWS 15', max: 15, laengen: [5, 10, 15, 20], kg10: 15, aufbau: 0.04, roll: 30 },
    { name: 'LWS 35', max: 35, laengen: [5, 10, 15, 20], kg10: 20, aufbau: 0.08, roll: 35 },
    { name: 'LWS 50', max: 50, laengen: [5, 10, 15, 20], kg10: 15, aufbau: 0.122, roll: 40 },
    { name: 'LWS 70', max: 70, laengen: [5, 10, 15], kg10: 45, aufbau: 0.133, roll: 50 },
    { name: 'LWS 100', max: 100, laengen: [5, 10, 15], kg10: 60, aufbau: null, roll: 65 }
  ];
  function typDaten() {
    var quelle = $('#lwp-typdaten');
    if (!quelle) return TYPEN_STANDARD;
    try {
      var d = JSON.parse(quelle.textContent);
      return d && d.length ? d : TYPEN_STANDARD;
    } catch (e) { return TYPEN_STANDARD; }
  }
  function kombiniere(typ, laenge) {
    var l = typ.laengen.slice().sort(function (a, b) { return b - a; });
    var gross = l[0], anz = {}, gedeckt = 0;
    var n = Math.floor(laenge / gross);
    if (n > 0) { anz[gross] = n; gedeckt = n * gross; }
    var rest = laenge - gedeckt;
    if (rest > 0) {
      var fuell = gross;
      for (var i = l.length - 1; i >= 0; i--) { if (l[i] >= rest) { fuell = l[i]; break; } }
      anz[fuell] = (anz[fuell] || 0) + 1;
      gedeckt += fuell;
    }
    var teile = [], summe = 0, kg = 0;
    Object.keys(anz).map(Number).sort(function (a, b) { return b - a; }).forEach(function (len) {
      teile.push(anz[len] + ' × ' + len + ' m');
      summe += anz[len];
      kg += anz[len] * len * (typ.kg10 / 10);
    });
    return { teile: teile, summe: summe, gedeckt: gedeckt, kg: kg };
  }
  function gewicht(kg) { return kg < 1000 ? fmt.format(Math.round(kg)) + '\u00a0kg' : fmt1.format(kg / 1000) + '\u00a0t'; }
  function dauer(min) {
    var s = Math.round(min * 60);
    if (s < 90) return s + ' s';
    var m = Math.floor(s / 60), r = s % 60;
    return m + ' min' + (r ? ' ' + r + ' s' : '');
  }
  function pyramide(svg, lagen) {
    /* Damm nach LFS BW Abb. 10a: Basis = Anzahl Lagen, je Lage ein Sack weniger.
       Fester Maßstab für bis zu 10 Lagen (1 m), damit der Damm sichtbar wächst. */
    if (!svg) return;
    var B = 152, H = 82, teile = [];
    for (var i = 0; i < lagen; i++) {
      var anzahl = lagen - i;
      var y = H - (i + 1) * 8.2;
      var x0 = (B - anzahl * 15.2) / 2;
      for (var j = 0; j < anzahl; j++) {
        teile.push('<rect x="' + (x0 + j * 15.2).toFixed(1) + '" y="' + y.toFixed(1) + '" width="14" height="7" rx="2.5"/>');
      }
    }
    svg.innerHTML = teile.join('');
  }
  /* Je Meter Damm nach LFS BW 2014 (Akademie Hochwasserschutz):
     0,5 m = 40 Säcke / 3 min, 1,0 m = 120 Säcke / 9 min bei 10 Helfern. */
  function jeMeter(hCm) {
    var h = hCm / 100;
    if (h <= 0.5) { var q = h / 0.5; return { saecke: 40 * q * q, minuten: 3 * q * q }; }
    var k = (Math.min(h, 1) - 0.5) / 0.5;
    return { saecke: 40 + 80 * k, minuten: 3 + 6 * k };
  }
  function zaehleAuf(el, ziel, format) {
    if (!el) return;
    var alt = parseFloat(el.getAttribute('data-wert') || '0');
    el.setAttribute('data-wert', ziel);
    if (ruhig || alt === ziel) { el.textContent = format(ziel); return; }
    var t0 = null;
    function schritt(t) {
      if (t0 === null) t0 = t;
      var k = Math.min(1, (t - t0) / 650);
      el.textContent = format(alt + (ziel - alt) * weich(k));
      if (k < 1) requestAnimationFrame(schritt);
    }
    requestAnimationFrame(schritt);
  }
  function symbole(el, anzahl, max, svg, animiert) {
    if (!el) return;
    var n = Math.min(anzahl, max), html = '';
    for (var i = 1; i <= n; i++) html += '<i style="--i:' + i + '">' + svg + '</i>';
    if (anzahl > max) html += '<em>+' + fmt.format(anzahl - max) + '</em>';
    el.innerHTML = html;
    if (!ruhig && animiert) { el.classList.remove('ist-neu'); void el.offsetWidth; el.classList.add('ist-neu'); }
  }
  function rechner() {
    $$('[data-lwp-rechner]').forEach(function (sek) {
      var SACK = 18, PALETTE = 70, LKW_KG = 8000, FUELLEN_JE_H = 80;
      var MET_F = 6.5, MET_V = 8.0, MET_L = 4.5, KG = 80, WURST = 280;
      var typen = typDaten();
      var hoehe = $('[data-lwp-hoehe]', sek), laenge = $('[data-lwp-laenge]', sek);
      var aus = function (n) { return $('[data-aus="' + n + '"]', sek); };
      var hinweis = $('[data-lwp-zielhinweis]', sek);
      var fehler = $('[data-lwp-fehler]', sek);
      var cta = $('[data-lwp-rechner-cta]', sek);
      var lkwSvg = (function () { var i = $('[data-aus="lkw_icons"] svg', sek) || $('.lwp-bilanz__label .lwp-ic--lkw', sek); return i ? i.outerHTML : ''; })();
      var wurstSvg = (function () { var i = $('[data-aus="wurst_icons"] svg', sek); return i ? i.outerHTML : '<svg class="lwp-ic lwp-ic--wurst" width="26" height="26" viewBox="0 0 24 24" aria-hidden="true"><g><rect x="1.5" y="8" width="21" height="8.4" rx="4.2" fill="currentColor" transform="rotate(-18 12 12.2)"/></g></svg>'; })();
      var gewaehltesZiel = '';
      if (!hoehe || !laenge) return;

      function wert(el) { var v = parseFloat(String(el.value).replace(',', '.')); return isFinite(v) ? v : NaN; }
      function typFuer(h) { for (var i = 0; i < typen.length; i++) { if (typen[i].max >= h) return typen[i]; } return typen[typen.length - 1]; }
      function stauOption(h) { var s = [15, 35, 50, 70, 100]; for (var i = 0; i < s.length; i++) { if (s[i] >= h) return 'bis ' + s[i] + ' cm'; } return 'bis 100 cm'; }
      var ganz = function (v) { return fmt.format(Math.round(v)); };

      function rechne(animiert) {
        var h = wert(hoehe), L = wert(laenge);
        var hmin = parseFloat(hoehe.min) || 10, hmax = parseFloat(hoehe.max) || 100;
        hoehe.style.setProperty('--fuell', ((h - hmin) / (hmax - hmin) * 100).toFixed(1) + '%');
        if (aus('hoehe')) aus('hoehe').textContent = fmt.format(h) + ' cm';
        if (!(L >= 1) || L > 2000) { if (fehler) fehler.hidden = false; return; }
        if (fehler) fehler.hidden = true;

        var m = jeMeter(h);
        var saecke = Math.ceil(m.saecke * L);
        var sandKg = saecke * SACK;
        var lkw = Math.max(1, Math.ceil(sandKg / LKW_KG));
        var paletten = Math.ceil(saecke / PALETTE);
        var hFuellen = saecke / FUELLEN_JE_H;
        var hVerlegen = m.minuten * L * 10 / 60;
        var kcal = Math.round((hFuellen * MET_F + hVerlegen * MET_V) * KG / 100) * 100;
        var wurst = Math.round(kcal / WURST);

        var typ = typFuer(h);
        var k = kombiniere(typ, L);
        var name = typ.name.replace(' ', ' ');

        if (aus('saecke')) aus('saecke').textContent = fmt.format(saecke) + ' Säcke';
        if (aus('sand')) aus('sand').textContent = gewicht(sandKg) + ' Sand füllen, laden, tragen';
        if (aus('elemente')) aus('elemente').textContent = k.summe + (k.summe === 1 ? ' Element' : ' Elemente');
        if (aus('kombi')) aus('kombi').textContent = name + ': ' + k.teile.join(' + ') + (k.gedeckt > L ? ', deckt ' + fmt.format(k.gedeckt) + ' m' : '') + ' · ' + gewicht(k.kg);
        zaehleAuf(aus('lkw'), lkw, ganz);
        zaehleAuf(aus('paletten'), paletten, ganz);
        zaehleAuf(aus('helfer'), Math.round(hFuellen + hVerlegen), ganz);
        zaehleAuf(aus('kcal'), kcal, ganz);
        zaehleAuf(aus('wurst'), wurst, ganz);
        symbole(aus('lkw_icons'), lkw, 8, lkwSvg, animiert);
        symbole(aus('wurst_icons'), wurst, 24, wurstSvg, animiert);

        if (aus('l_kiste')) aus('l_kiste').textContent = gewicht(k.kg) + ' Sperre, je 10 m gerollt Ø ' + typ.roll + ' cm';
        var zeitZeile = aus('zeit'), kcalZeile = aus('l_kcal');
        if (typ.aufbau) {
          var min = typ.aufbau * L;
          if (zeitZeile) { zeitZeile.textContent = 'ca. ' + dauer(min) + ' auslegen (EVH)'; zeitZeile.closest('li').hidden = false; }
          if (kcalZeile) { kcalZeile.textContent = 'ca. ' + fmt.format(Math.max(1, Math.round(2 * min / 60 * MET_L * KG))) + ' kcal'; kcalZeile.closest('li').hidden = false; }
        } else {
          if (zeitZeile) zeitZeile.closest('li').hidden = true;
          if (kcalZeile) kcalZeile.closest('li').hidden = true;
        }
        if (aus('pointe')) aus('pointe').textContent = gewicht(sandKg) + ' Sand, ' + fmt.format(lkw) + (lkw === 1 ? ' Lkw-Ladung und ' : ' Lkw-Ladungen und ') + fmt.format(wurst) + (wurst === 1 ? ' Bratwurst. ' : ' Bratwürste. ') + 'Oder ' + gewicht(k.kg) + ' Sperre und zwei Einsatzkräfte.';

        pyramide($('[data-lwp-pyr]', sek), Math.max(1, Math.ceil(h / 10)));
        var mini = $('[data-lwp-mini-wand]', sek);
        if (mini) {
          var wy = Math.min(100, h) * 0.8;
          var wasser = $('[data-teil="wasser"]', mini), wand = $('[data-teil="wand"]', mini);
          if (wasser) wasser.setAttribute('d', 'M4 86 V' + (86 - wy * 0.9).toFixed(1) + ' H' + (68 - wy * 0.207).toFixed(1) + ' L68 86 Z');
          if (wand) wand.setAttribute('d', 'M68 84 L' + (68 - wy * 0.23).toFixed(1) + ' ' + (84 - wy).toFixed(1));
        }
        if (animiert && !ruhig) $$('.lwp-ergebnis__karte', sek).forEach(function (c) { c.classList.remove('ist-neu'); void c.offsetWidth; c.classList.add('ist-neu'); });
        if (cta) {
          var daten = { stau: stauOption(h), laenge: fmt.format(L) + ' m', text: 'Schutzlinie aus dem Rechner: ' + fmt.format(L) + ' m, Stauhöhe ' + fmt.format(h) + ' cm, Vorschlag ' + k.summe + ' × ' + typ.name + ' (' + k.teile.join(' + ') + ').' };
          if (gewaehltesZiel) daten.ziel = gewaehltesZiel;
          cta.setAttribute('data-lwp-vorbelegen', JSON.stringify(daten));
        }
      }
      var zeitgeber;
      function sanft() { clearTimeout(zeitgeber); zeitgeber = setTimeout(function () { rechne(true); }, 180); }
      hoehe.addEventListener('input', function () { if (aus('hoehe')) aus('hoehe').textContent = fmt.format(wert(hoehe)) + ' cm'; hoehe.style.setProperty('--fuell', ((wert(hoehe) - 10) / 90 * 100).toFixed(1) + '%'); sanft(); });
      laenge.addEventListener('input', sanft);
      $$('[data-lwp-schritt-l]', sek).forEach(function (b) {
        b.addEventListener('click', function () {
          var v = wert(laenge) || 0;
          v = Math.max(1, Math.min(2000, v + parseFloat(b.getAttribute('data-lwp-schritt-l'))));
          laenge.value = v;
          rechne(true);
        });
      });
      $$('input[name="lwp-ziel"]', sek).forEach(function (r) {
        r.addEventListener('change', function () {
          if (!r.checked) return;
          gewaehltesZiel = r.getAttribute('data-form') || '';
          var h = parseFloat(r.getAttribute('data-hoehe')), L = parseFloat(r.getAttribute('data-laenge'));
          if (h) hoehe.value = h;
          if (L) laenge.value = L;
          if (hinweis) hinweis.textContent = r.getAttribute('data-hinweis') || '';
          rechne(true);
        });
      });
      /* Startwerte: Ausgabe steht schon serverseitig; Zähler merken sich nur ihren Wert. */
      ['lkw', 'paletten', 'helfer', 'kcal', 'wurst'].forEach(function (n) { var e = aus(n); if (e) e.setAttribute('data-wert', String(parseFloat(e.textContent.replace(/\./g, '')) || 0)); });
      rechne(false);
    });
  }

  /* ── 6 Formular vorbelegen ────────────────────────────────────────── */
  function setzeAuswahl(sel, wert) {
    if (!sel || !wert) return;
    for (var i = 0; i < sel.options.length; i++) {
      if (sel.options[i].value === wert) { sel.selectedIndex = i; return; }
    }
  }
  function vorbelegen() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest('[data-lwp-vorbelegen]');
      if (!a) return;
      var d;
      try { d = JSON.parse(a.getAttribute('data-lwp-vorbelegen') || '{}'); } catch (x) { d = {}; }
      var form = document.getElementById('ContactForm');
      if (!form) return;
      setzeAuswahl($('#LwsZiel', form), d.ziel);
      setzeAuswahl($('#LwsStau', form), d.stau);
      var l = $('#LwsLaenge', form);
      if (l && d.laenge) l.value = d.laenge;
      var t = $('#LwsText', form);
      if (t && d.text) t.value = d.text;
      var karte = $('.lwsf__karte', form) || form;
      karte.classList.remove('lwp-vorbelegt');
      void karte.offsetWidth;
      karte.classList.add('lwp-vorbelegt');
    });
  }

  function start() {
    einblenden();
    zaehler();
    querschnitte();
    geschichten();
    galerien();
    typwahl();
    rechner();
    vorbelegen();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

